import styles from './DailyView.module.css';

export function DailyViewSkeleton() {
  return (
    <div className={styles.container}>
      <aside className={styles.skeletonSidebar} aria-hidden="true">
        <div className={styles.skeletonBlock} />
        <div className={styles.skeletonRow}>
          <div className={styles.skeletonChip} />
          <div className={styles.skeletonChip} />
          <div className={styles.skeletonChip} />
        </div>
        <div className={styles.skeletonList}>
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLineShort} />
          <div className={styles.skeletonLine} />
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.skeletonHeader}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonActions}>
            <div className={styles.skeletonCircle} />
            <div className={styles.skeletonCircle} />
          </div>
        </div>
        <div className={styles.skeletonWeekStrip}>
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
          <div className={styles.skeletonPill} />
        </div>
        <div className={styles.timelineWrapper}>
          <div className={styles.skeletonTimeline}>
            <div className={styles.skeletonBlockWide} />
            <div className={styles.skeletonBlockWide} />
            <div className={styles.skeletonBlockWide} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default DailyViewSkeleton;
